import React, { PropTypes } from 'react';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 100,
  },
};

const tableStyles = {
  column: {
    code: {
      width: 57,
    },
    brand: {
      width: 121,
    },
    zhTwName: {
      width: 181,
    },
    enName: {
      width: 190,
    },
    status: {
      width: 145,
    },
    order: {
      width: 50,
    },
  },
};

const queueCodes = [
  {
    value: 'A',
    text: 'A',
  },
  {
    value: 'B',
    text: 'B',
  },
  {
    value: 'C',
    text: 'C',
  },
  {
    value: 'D',
    text: 'D',
  },
  {
    value: 'E',
    text: 'E',
  },
  {
    value: 'F',
    text: 'F',
  },
];

const QueueListRow = ({ queue, services, rowStyles, onChange, onDelete }) => {
  const wrapOnChange = (fnc, field, event, value) => {
    fnc(field, value);
  };

  const wrapSelectFieldOnChange = (fnc, field, event, index, value) => {
    fnc(field, value);
  };

  return (
    <TableRow>
      <TableRowColumn style={rowStyles.column.code}>
        {/*<TextField*/}
        {/*name="code"*/}
        {/*value={queue.code}*/}
        {/*// onChange={wrapOnChange.bind(this, onChange, 'name.zhTW')}*/}
        {/*type="text"*/}
        {/*disabled={true}*/}
        {/*/>*/}
        <SelectField
          value={queue.code}
          onChange={wrapSelectFieldOnChange.bind(this, onChange, 'code')}
          disabled={true}
        >
          {
            _.map(queueCodes, (queueCode, index) => (
              <MenuItem key={index} value={queueCode.value} primaryText={queueCode.text} />
            ))
          }
        </SelectField>
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.brand}>
        <SelectField
          value={queue.bookingServiceId}
          onChange={wrapSelectFieldOnChange.bind(this, onChange, 'bookingServiceId')}
          disabled={true}
        >
          <MenuItem value={''} primaryText={'不需預約'} />
          {
            _.map(services, (service, index) => (
              <MenuItem key={index} value={service._id} primaryText={'需要'} />
            ))
          }
        </SelectField>
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.zhTwName}>
        {
          !_.size(queue.bookingServiceId) &&
          <TextField
            hintText="中文名稱"
            name="name.zhTW"
            value={queue.name.zhTW}
            onChange={wrapOnChange.bind(this, onChange, 'name.zhTW')}
            type="text"
          />
        }

      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.enName}>
        {
          !_.size(queue.bookingServiceId) &&
          <TextField
            hintText="英文名稱"
            name="name.en"
            value={queue.name.en}
            onChange={wrapOnChange.bind(this, onChange, 'name.en')}
            type="text"
          />
        }
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.status}>
        <RadioButtonGroup
          name="status"
          defaultSelected="active"
          valueSelected={queue.status}
          style={styles.radioButtonGroup}
          onChange={wrapOnChange.bind(this, onChange, 'status')}>
          <RadioButton
            value="active"
            label="啟用"
            style={styles.radioButton}
          />
          <RadioButton
            value="inactive"
            label="停用"
            style={styles.radioButton}
          />
        </RadioButtonGroup>
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.order}>
        <TextField
          name="order"
          value={queue.order}
          onChange={wrapOnChange.bind(this, onChange, 'order')}
          // disabled={true}
          pattern="^[0-9]"
          type="text" />
      </TableRowColumn>

      {/*<TableRowColumn style={rowStyles.column.button}>*/}
      {/*/!*<RaisedButton*!/*/}
      {/*/!*label="刪除"*!/*/}
      {/*/!*secondary={true}*!/*/}
      {/*/!*onClick={onDelete} />*!/*/}
      {/*</TableRowColumn>*/}
    </TableRow>
  );
};

QueueListRow.propTypes = {
  queue: PropTypes.object.isRequired,
  services: PropTypes.array.isRequired,
  rowStyles: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default QueueListRow;



// WEBPACK FOOTER //
// client/adminPanel/panel/queues/QueueListRow.js